import React from 'react';
import { Link } from 'react-router-dom';

interface Props {
    name: string | null | undefined;
    to: string;
}

export const EntityNameLink = ({ name, to }: Props) => {
    if (!name) return <div>&ndash;</div>;

    return (
        <Link
            role="button"
            className="f-text-medium-content f-text-single-line f-text-semibold f-color-dark-black-s100"
            to={to}
        >
            {name}
        </Link>
    );
};
